export default __webpack_public_path__ + "static/media/info-filled-not-circle.20d232c6.svg";